// BR_Custom Page Menu Active Anchor
(() => {
  const initPageMenu = () => {
    const pageMenu = document.querySelector(".section-header.page_menu");
    const nav = document.querySelector(".page_menu__nav");
    if (!pageMenu || !nav) return;

    const links = Array.from(
      nav.querySelectorAll('.page_menu__link[href^="#"]'),
    );
    if (!links.length) return;

    const sections = links
      .map((link) => {
        const id = link.getAttribute("href").slice(1);
        const target = document.getElementById(id);
        return target ? { link, target } : null;
      })
      .filter(Boolean);

    if (!sections.length) return;

    links.forEach((link) => {
      link.addEventListener("click", () => {
        window.setTimeout(() => {
          history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search,
          );
        }, 0);
      });
    });

    const updateAnchorOffset = () => {
      const menuTop = parseFloat(window.getComputedStyle(pageMenu).top) || 0;
      const menuHeight = pageMenu.getBoundingClientRect().height;
      const offset = menuTop + menuHeight;

      sections.forEach(({ target }) => {
        target.style.scrollMarginTop = `${offset}px`;
      });
    };

    const setActiveLink = (activeLink) => {
      links.forEach((link) => {
        link.classList.toggle("is-active", link === activeLink);
      });
    };

    const updateActiveLink = () => {
      const menuTop = parseFloat(window.getComputedStyle(pageMenu).top) || 0;
      const menuHeight = pageMenu.getBoundingClientRect().height;
      const triggerPoint = menuTop + menuHeight;

      let current = null;

      sections.forEach((section) => {
        if (section.target.getBoundingClientRect().top <= triggerPoint + 1) {
          current = section;
        }
      });

      if (current) {
        setActiveLink(current.link);
      }
    };

    let ticking = false;

    const requestUpdate = () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        updateActiveLink();
        ticking = false;
      });
    };

    updateAnchorOffset();
    updateActiveLink();

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", () => {
      updateAnchorOffset();
      requestUpdate();
    });
  };

  initPageMenu();
})();
// End BR_Custom Page Menu Active Anchor
